import { render, staticRenderFns } from "./CustomFormElement.vue?vue&type=template&id=779bbc6b"
import script from "./CustomFormElement.vue?vue&type=script&lang=js"
export * from "./CustomFormElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports